export default "/images/stock_transfer.png?f7df416b6f5119216f29735302a4a844";